// components/forms/MedicalHistoryForm.js
import React from 'react';

function MedicalHistoryForm({ data, setData }) {
    const handleChange = (field, value) => {
        setData({
            ...data,
            [field]: value
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">既往病史</h2>

            <div className="grid grid-cols-1 gap-4">
                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="hypertension"
                        className="mr-2"
                        checked={data.hypertension}
                        onChange={(e) => handleChange('hypertension', e.target.checked)}
                    />
                    <label htmlFor="hypertension" className="text-sm font-medium text-gray-700">高血压病史</label>
                </div>

                {data.hypertension && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">患病年限</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded"
                                placeholder="例如：10年"
                                value={data.hypertensionYears}
                                onChange={(e) => handleChange('hypertensionYears', e.target.value)}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">血压控制情况</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded"
                                placeholder="例如：150/90"
                                value={data.hypertensionControl}
                                onChange={(e) => handleChange('hypertensionControl', e.target.value)}
                            />
                        </div>
                    </div>
                )}

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="diabetes"
                        className="mr-2"
                        checked={data.diabetes}
                        onChange={(e) => handleChange('diabetes', e.target.checked)}
                    />
                    <label htmlFor="diabetes" className="text-sm font-medium text-gray-700">糖尿病病史</label>
                </div>

                {data.diabetes && (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 ml-6">
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">患病年限</label>
                            <input
                                type="text"
                                className="w-full p-2 border rounded"
                                placeholder="例如：8年"
                                value={data.diabetesYears}
                                onChange={(e) => handleChange('diabetesYears', e.target.value)}
                            />
                        </div>

                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1">血糖控制情况</label>
                            <select
                                className="w-full p-2 border rounded"
                                value={data.diabetesControl}
                                onChange={(e) => handleChange('diabetesControl', e.target.value)}
                            >
                                <option value="">请选择</option>
                                <option value="良好">良好</option>
                                <option value="一般">一般</option>
                                <option value="欠佳">欠佳</option>
                                <option value="差">差</option>
                            </select>
                        </div>
                    </div>
                )}

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="hyperlipidemia"
                        className="mr-2"
                        checked={data.hyperlipidemia}
                        onChange={(e) => handleChange('hyperlipidemia', e.target.checked)}
                    />
                    <label htmlFor="hyperlipidemia" className="text-sm font-medium text-gray-700">高脂血症</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="atrialFibrillation"
                        className="mr-2"
                        checked={data.atrialFibrillation}
                        onChange={(e) => handleChange('atrialFibrillation', e.target.checked)}
                    />
                    <label htmlFor="atrialFibrillation" className="text-sm font-medium text-gray-700">心房颤动或其他心脏疾病</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="previousStroke"
                        className="mr-2"
                        checked={data.previousStroke}
                        onChange={(e) => handleChange('previousStroke', e.target.checked)}
                    />
                    <label htmlFor="previousStroke" className="text-sm font-medium text-gray-700">既往脑卒中史</label>
                </div>

                <div className="flex items-center">
                    <input
                        type="checkbox"
                        id="previousTIA"
                        className="mr-2"
                        checked={data.previousTIA}
                        onChange={(e) => handleChange('previousTIA', e.target.checked)}
                    />
                    <label htmlFor="previousTIA" className="text-sm font-medium text-gray-700">既往短暂性脑缺血发作(TIA)史</label>
                </div>

                <div className="mt-4">
                    <label className="block text-sm font-medium text-gray-700 mb-1">过敏史</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        placeholder="如有药物过敏，请注明"
                        value={data.allergies}
                        onChange={(e) => handleChange('allergies', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}

export default MedicalHistoryForm;